import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom"; 
import App from "./App";

// Global reset
const globalStyle = document.createElement("style");
globalStyle.innerHTML = `
 * {
 box-sizing: border-box;
 }
 body, html {
 margin: 0;
 padding: 0;
 width: 100%;
 height: 100%;
 }
`;
document.head.appendChild(globalStyle);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Router>
      <App />
    </Router>
  </React.StrictMode>
);
